import { patternString } from "./patternStrings";
import { settings } from "./settings";

export * from "./patternStrings";
export * from "./settings";

export const CoreConfigImports = [
  settings,
  patternString,
]